import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getMetaSemanalByEmpleado.php';

export default function getMetaSemanalByEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}